export default __webpack_public_path__ + "static/media/Shot_15.0000.ac136828.png";